import { Action } from "redux";
import { ChangeToColorMappingType } from "../../types";

export const SAVE_CHANGE_TYPE_COLORING = "SAVE_CHANGE_TYPE_COLORING";

export interface SaveChangeTypeColoringAction extends Action {
    changeToColorMapping: ChangeToColorMappingType;
}

export const saveChangeTypeColoringAction = (
    changeToColorMapping: ChangeToColorMappingType
): SaveChangeTypeColoringAction => {
    return {
        type: SAVE_CHANGE_TYPE_COLORING,
        changeToColorMapping: changeToColorMapping,
    };
};
